<script>
  import { viewActive } from '../../apps/imd/stores';
  import UseResource from '../svg/UseResource.svelte';
  import { translateOrDefault } from '~/data-utils';

  let iconSvg = 'im_info';
  let iconTitle = '';
  $: {
    switch ($viewActive) {
    case 'start':
    case 'thirdparty':
      iconSvg = 'im_info';
      iconTitle = '';
      break;
    case 'list':
    case 'store':
      iconSvg = 'ic_store';
      iconTitle = translateOrDefault('common.stores');
      break;
    case 'tips':
      iconSvg = 'ic_offer';
      iconTitle = translateOrDefault('common.offers');
      break;
    case 'news':
      iconSvg = 'ic_news';
      iconTitle = translateOrDefault('common.eventsAndNews');
      break;
    case 'hours':
      iconSvg = 'ic_clock';
      iconTitle = translateOrDefault('common.openingHours');
      break;
    case 'lunchmenu':
      iconSvg = 'ic_lunch_menu';
      iconTitle = translateOrDefault('store.lunchToday');
      break;
    case 'maps':
      iconSvg = 'ic_map-pin';
      iconTitle = translateOrDefault('common.map');
      break;
    case 'search':
    case 'searchresults':
      iconSvg = 'ic_search';
      iconTitle = translateOrDefault('common.search');
      break;
    }
  }
</script>

<div class="header-icon">
  <UseResource name={iconSvg}/>
  {#if iconTitle!=''}
  <p class="header-icon__text">{@html iconTitle}</p>
  {/if}
</div>
